$(document).on("turbolinks:load", () => {
  $("#product_status").on("change", ({ target: { value } }) => {
    if (value === "inactive") $("#product-alert").modal("show");
  });
});
